import {useAssertedContext} from '@pexip/media-components';

import {InfinityContext} from '../contexts/infinity.context';

export const useInfinityContext = () => useAssertedContext(InfinityContext);
